import Entity from 'utilities/entity';
import Skill from './skill';

class Groowtorial extends Entity {

    skills() {
        return this.hasMany(Skill);
    }

}

export default new Groowtorial();
